import React from 'react';
import classNames from "classnames";
import usePlayersContext from "../hooks/usePlayersContext";

const Description = ({ episodeDescription }) => {
    const { showDescription } = usePlayersContext();
    const classes = classNames('player-app__item-description', {
        'player-app__item-description-visible': showDescription && episodeDescription
    });
    return (
        <div className={classes}>
            <p>{episodeDescription?.replace(/<[^>]+>/g, '')}</p>
        </div>
    );
};

export default Description;
